/*
 * @Author: your name
 * @Date: 2022-02-09 11:11:51
 * @LastEditTime: 2022-05-08 14:57:13
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\convert-service.js
 */


/**  
 * 生成指定格式的时间  
 * @param {*} timeStemp 时间戳  
 * @param {*} flag 格式符号  
 */  
 const ToString  = function(dateStr, pattern, flag = '-') {  
    let dt = new Date(dateStr);
    if(typeof(dateStr) == 'string'){
        if (dateStr.indexOf("Z") > 0){
            dt = new Date(dateStr)
        }else{
            var myDate = new Date(dateStr + '+0800');
            if (myDate == 'Invalid Date') {
                dateStr = dateStr.replace(/T/g, ' '); //去掉T
                dateStr = dateStr.replace(/-/g, '/');
                dateStr = dateStr.replace(/\.\d+/, ' ');//去掉毫秒
                dt = new Date(dateStr + '+0800');       
            }    
        }
    }
    let y = dt.getFullYear()
    let m = (dt.getMonth() + 1).toString().padStart(2, '0')
    let d = dt.getDate().toString().padStart(2, '0')
    let hh = dt.getHours().toString().padStart(2, '0')
    let mm = dt.getMinutes().toString().padStart(2, '0')
    let ss = dt.getSeconds().toString().padStart(2, '0')
    if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}${flag}${m}${flag}${d}`
    }
    else if(pattern.toLowerCase()==='yyyy-mm-dd hh:mm'){
        return `${y}${flag}${m}${flag}${d} ${hh}:${mm}`
    }
    else if(pattern.toLowerCase()==='yyyy-mm'){
        return `${y}${flag}${m}`
    }
    else if(pattern.toLowerCase()==='hh:mm:ss'){
        return `${hh}:${mm}:${ss}`
    }
    else if(pattern.toLowerCase()==='hh:mm'){
        return `${hh}:${mm}`
    }
    else if(pattern.toLowerCase()==='mm:ss'){
        return `${mm}:${ss}`
    }
    else if(pattern.toLowerCase()==='yyyy'){
        return `${y}`
    }
    else if(pattern.toLowerCase()==='mm'){
        return `${m}`
    }
    else if(pattern.toLowerCase()==='dd'){
        return `${d}`
    }
    else if(pattern.toLowerCase()==='yyyy-ww'){
        return `${this.getYearWeek(dateStr)}`
    }
    else if(pattern.toLowerCase()==='mm-ww'){
        return `${this.getMonthWeek(dateStr)}`
    }
    else if(pattern.toLowerCase()==='yyyymmdd'){
        return `${y}${m}${d}`
    }
    else {
        return `${y}${flag}${m}${flag}${d} ${hh}:${mm}:${ss}`
    }
}
/**
* 枚举转换数据字典处理 (这里的数据字典含义是固定字段名称,与数据字典字段保持一致) 
* @params enums 枚举
*/
const EnumToDictionary = function(enums, appendBlank = false){
    let list = [];
    if(appendBlank){
        list.push({value: 0, label: '---请选择---', title: '---请选择---'})
    }
    if(enums){
        for(let item in enums){
            list.push({ label: enums[item], title: enums[item], value: parseInt(item)})
        }
    }
    return list;
}

/**
 * 保留小数位
 * @param {*} num 
 * @param {*} decimal 
 * @returns 
 */
const ToDecimal = function(num, decimal = 2) {
    if (isNaN(num)) {
        return 0;
    }
    const p1 = Math.pow(10, decimal + 1);
    const p2 = Math.pow(10, decimal);
    return Math.round(num * p1 / 10) / p2;
}

/**
 * 保留小数
 * @param {} num 
 * @param {} decimal 
 * @returns 
 */
const ToFixed = function(num, decimal = 2) {
    return round(num, decimal).toFixed(decimal);
}


//阿拉伯数字转中文数字
const NumberToChinese = function(num) {
    if (!/^\d*(\.\d*)?$/.test(num)) {
        alert("Number is wrong!");
        return "Number is wrong!";
    }
    var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
    var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
    var a = ("" + num).replace(/(^0*)/g, "").split("."),
        k = 0,
        re = "";
    for (var i = a[0].length - 1; i >= 0; i--) {
        switch (k) {
            case 0:
                re = BB[7] + re;
                break;
            case 4:
                if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                    re = BB[4] + re;
                break;
            case 8:
                re = BB[5] + re;
                BB[7] = BB[5];
                k = 0;
                break;
        }
        if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
        if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
        k++;
    }
    if (a.length > 1) //加上小数部分(如果有小数部分)
    {
        re += BB[6];
        for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
    }
    return re;
}
 
   

export default {
    ToString,
    EnumToDictionary,
    ToDecimal,
    ToFixed,
    NumberToChinese,
}